import { ChevronDownIcon, SparklesIcon } from "lucide-react";

import { RateAllCandidaciesSection } from "./RateAllCandidaciesSection";
import { SectionStatusIndicator } from "./SectionStatusIndicator";
import { Column, Row, Text } from "@/components";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

export const JobAdminSection = () => {
  return (
    <SectionStatusIndicator complete>
      <Collapsible className="group/collapsible">
        <Column className="overflow-hidden rounded-lg border border-slate-200 bg-white">
          <CollapsibleTrigger className="flex w-full cursor-pointer items-center justify-between px-6 py-4">
            <Row className="items-center gap-2">
              <SparklesIcon className="h-4 w-4 text-slate-500" />
              <Text variant="header">Job Admin</Text>
            </Row>
            <ChevronDownIcon className="h-4 w-4 text-slate-500 transition-transform duration-200 group-data-[state=closed]/collapsible:-rotate-90" />
          </CollapsibleTrigger>
          <CollapsibleContent>
            <Column className="border-t border-slate-100 px-6 pb-5 pt-4">
              <RateAllCandidaciesSection />
            </Column>
          </CollapsibleContent>
        </Column>
      </Collapsible>
    </SectionStatusIndicator>
  );
};
